import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header, Paper } from '../components';
import Button from '../components/Button';
import * as React from 'react';
const ExistingAccount = () => {
    return (_jsxs(Paper, { children: [_jsx(Header, Object.assign({ id: 'existing-account-header' }, { children: "REDAN KUND HOS OSS?" })), _jsx("p", Object.assign({ style: {
                    marginBottom: '16px',
                    fontSize: '14px',
                } }, { children: "Om du redan \u00E4r kund hos oss, klicka p\u00E5 knappen nedan f\u00F6r att skapa en webinloggning." })), _jsx(Button, Object.assign({ "aria-labelledby": 'existing-account-header', "aria-describedby": 'existing-account-description' }, { children: "SKAPA WEBBINLOG" })), _jsx("span", Object.assign({ id: 'existing-account-description', style: {
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    padding: '0',
                    margin: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0,0,0,0)',
                    whiteSpace: 'nowrap',
                    border: '0',
                } }, { children: "Klicka f\u00F6r att skapa en webinloggning med ditt befintliga kundkonto" }))] }));
};
export default ExistingAccount;
